/**
 * @generated SignedSource<<0baaabfafa9014e928830dcf1ebd9346>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type commentHeaderFeaturesArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle">;
  readonly " $fragmentType": "commentHeaderFeaturesArticle";
};
export type commentHeaderFeaturesArticle$key = {
  readonly " $data"?: commentHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "commentHeaderFeaturesArticle"
};

(node as any).hash = "14815839f9ea702e42b07359df163b01";

export default node;
